import { useEffect, useRef, useState } from "react";
// import * as XLSX from "xlsx";
import { callButtonGeneral } from "../../DataApi/generalApis/callButtonGeneral";
import { useSession } from "../../authentications/SessionContext";
import { enqueueSnackbar } from "notistack";
import { primaryColor } from "../../utilities/colors";
import sampleTemplate from "../../assets/files/Final_v1_Product_Template_sample.xlsx";
import { usePolling } from "../../contexts/PollingContext";

function ExcelReader({ onClose, reloadList, handleProductWizardClose }) {
  const [data, setData] = useState(null);
  const [isLoadingData, setIsLoadingData] = useState(false);

  const [errorMessages, setErrorMessages] = useState([]);
  const { sessionInfo } = useSession();
  const { company_id, context, isVTEX } = sessionInfo;

  const { startPolling } = usePolling();

  const handleFileUpload = async (event) => {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();

      // Create a Promise to handle the async behavior
      const base64Promise = new Promise((resolve, reject) => {
        reader.onloadend = () => {
          const base64String = reader.result;
          resolve(base64String);
        };
        reader.onerror = (error) => {
          reject(error);
        };
      });

      reader.readAsDataURL(file); // Convert file to Base64 string

      try {
        let base64String = await base64Promise; // Wait for the base64 conversion

        // Log the full Base64 string to debug
        // console.log("Full base64String:", base64String);

        // Remove the MIME type prefix
        if (base64String) {
          base64String = base64String.split(",")[1];
          //   console.log("Base64 without MIME type:", base64String);
          setData(base64String);
        }
      } catch (error) {
        console.error("Error reading file:", error);
      }
    }
  };
  const downloadFile = () => {
    const fileUrl = sampleTemplate;

    const link = document.createElement("a");
    link.href = fileUrl;
    link.download = "sample_template.xlsx";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };
  const handleProcessFile = async () => {
    if (isLoadingData) return;

    if (data) {
      setIsLoadingData(true);

      try {
        // 1. Call the first API when triggered (callButtonGeneral)
        let response = await callButtonGeneral({
          company_id,
          method: "import_file_xlsx",
          model: "product.template",
          args: [data],
          context,
        });
        if (response?.result?.result) {
          startPolling(response.result.result, reloadList); // Start polling once the file is uploaded successfully
        }
      } catch (error) {
        console.error("Error reading file:", error);
      } finally {
        setIsLoadingData(false);
        onClose();
        handleProductWizardClose();
      }
    } else {
      enqueueSnackbar("File not selected!", {
        variant: "warning",
        persist: false,
      });
    }
  };

  // useEffect(() => {
  //   if (!importedFileId || isLoadingData) return; // Don't start polling if no file ID or still loading

  //   // Define an async function for polling
  //   const pollApi = async () => {
  //     try {
  //       // Call the search API to get job queue records
  //       let jobQueueResponse = await searchReadGeneral({
  //         company_id,
  //         domain: [["imported_file_id", "=", importedFileId]],
  //         context,
  //         fields: jobQueueFields,
  //         pagination: jobQueuePagination,
  //         model: "queue.job",
  //       });

  //       if (jobQueueResponse?.result?.records.length > 0) {
  //         // Process the response and update notifications and toast messages
  //         jobQueueResponse.result.records.forEach((record) => {
  //           const { id, name, state } = record;
  //           const existingNotification = notifications.find((n) => n.id === id);

  //           const colorMap = {
  //             done: "green",
  //             failed: "red",
  //             pending: "yellow",
  //             enqueued: "blue",
  //           };

  //           // Add or update notification
  //           if (!existingNotification) {
  //             addNotification({
  //               id,
  //               name,
  //               state,
  //               color: colorMap[state],
  //             });
  //             toast(name, {
  //               toastId: id,
  //               autoClose: false,
  //               closeOnClick: false,
  //               style: { backgroundColor: colorMap[state] },
  //             });
  //           } else if (existingNotification.state !== state) {
  //             updateNotification({ id, state, color: colorMap[state] });
  //             toast.update(id, {
  //               render: name,
  //               style: { backgroundColor: colorMap[state] },
  //             });
  //           }
  //         });

  //         // 3. Stop polling if all records are "done" or "failed"
  //         const allProcessed = jobQueueResponse.result.records.every((record) =>
  //           ["done", "failed"].includes(record.state)
  //         );

  //         if (allProcessed) {
  //           console.log("allProcessed", allProcessed);
  //           clearInterval(intervalRef.current); // Stop polling
  //         }
  //       }
  //     } catch (error) {
  //       console.error("Polling Error:", error);
  //     }
  //   };

  //   // Start polling every 5 seconds
  //   intervalRef.current = setInterval(pollApi, 5000);

  //   // Cleanup function to stop polling on unmount or if the importedFileId changes
  //   return () => {
  //     clearInterval(intervalRef.current); // Cleanup polling
  //   };
  // }, [
  //   importedFileId,
  //   isLoadingData,
  //   notifications,
  //   addNotification,
  //   updateNotification,
  // ]);

  return (
    <div className="me-4 my-4">
      <div className="d-flex align-items-center justify-content-between mt-4 modal-header">
        <h4 className="text-secondary fw-bold">Upload XLXS</h4>
        <a
          className="text-danger"
          onClick={onClose}
          style={{ cursor: "pointer" }}
        >
          <i className="bi bi-x-square-fill"></i>
        </a>
      </div>
      <div className="d-flex align-items-center justify-content-between mt-4">
        <input
          type="file"
          className="form-control"
          accept=".xls,.xlsx,.csv"
          onChange={handleFileUpload}
        />
        <button
          className="btn vtex-btn d-flex justify-content-center align-items-center"
          onClick={handleProcessFile}
          style={{
            background: isVTEX ? "#000000" : "#ff5837",
            color: isVTEX ? primaryColor.primary : "#FFFFFF",
          }}
        >
          <span
            className={`spinner-border spinner-border-custom fa-sm ${
              !isLoadingData ? "d-none" : ""
            }`}
            role="status"
          ></span>
          <span className="">Process</span>
        </button>
      </div>
      <div
        className="d-flex justify-content-start align-items-center mt-2"
        style={{ color: isVTEX ? "#000000" : "#ff5837" }}
      >
        <i className="bi bi-info-circle-fill mx-2" aria-hidden="true"></i>
        <p className="m-0">
          <em>
            Hint: Ensure you follow the template to avoid issues.
            <a
              className="cursor-pointer fs-6 text-capitalize text-decoration-underline"
              onClick={downloadFile}
              style={{ color: isVTEX ? "#000000" : "#ff5837" }}
            >
              Get Template?
            </a>
          </em>
        </p>
      </div>

      {errorMessages.length > 0 && (
        <ul className="nav nav-tabs mt-4">
          <li className="nav-item">
            <a
              className="nav-link active fw-bold text-danger"
              aria-current="page"
              href="#"
            >
              <i className="bi bi-exclamation-triangle-fill mx-2"></i>
              <span>Issues</span>
            </a>
          </li>
        </ul>
        // <div className="d-flex justify-content-center align-items-center">
        //   <h6 className="fw-bold text-secondary">Issues</h6>
        // </div>
      )}
      <div
        className="d-flex flex-column align-items-start justify-content-start mt-4"
        style={{ overflowY: "scroll", maxHeight: "200px" }}
      >
        {errorMessages.map((errorMessage, index) => (
          <div
            key={index}
            className="alert alert-danger text-start"
            style={{ padding: "9px !important" }}
            role="alert"
          >
            {errorMessage}
          </div>
        ))}
      </div>
      {/* <div
        className="mt-3 container"
        style={{ overflowY: "scroll", height: "inherit", maxHeight: "inherit" }}
      >
        {data.length > 0 && (
          <table className="table table-bordered table-striped">
            <thead className="table-dark">
              <tr>
                {data[0].map((cell, index) => (
                  <th key={index}>{cell}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {data.slice(1).map((row, rowIndex) => (
                <tr key={rowIndex}>
                  {row.map((cell, cellIndex) => (
                    <td key={cellIndex}>{cell}</td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div> */}
    </div>
  );
}

export default ExcelReader;
